// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import PipRequiredItem from '@deere/cps-it.warranty-model-factory/lib/pip-required-item';
import {buildNumber} from '../../../shared/services/build-number';

const LaborDetails = props =>
    <li className='labor-item'>
        <FormattedMessage
            id='LABOR_ITEM_DETAILS'
            values={{
                description: props.item.description,
                quantity: buildNumber(props.item.quantity),
                unit: props.item.unit
            }}
        />
    </li>;

LaborDetails.displayName = 'LaborDetails';
LaborDetails.propTypes = {
    item: PropTypes.instanceOf(PipRequiredItem).isRequired
};

export default LaborDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/labor-details.js